const removeTrailingSlash = (str) => {
    return str?.replace(/\/+$/, '');
}

const getKeyFormatted = (key) => {
    const customLabels = { 'burpevidence_set': 'Evidence' };
    if (customLabels[key]) {
        return customLabels[key];
    }

    const label = key.replace(/_/g, ' ');
    return label.charAt(0).toUpperCase() + label.slice(1);
};

function generateUniqueString(length = 16) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}


export { generateUniqueString, getKeyFormatted, removeTrailingSlash };
